import styled, { css } from "styled-components";

export const Video = styled.iframe`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;
